module.exports = __webpack_public_path__ + "assets/images/Create-product.svg";